import { Row, Col, Container, Button } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Socials from "../Utils/socials";
import { Link } from "react-router-dom";

const Footer = () => {
  let date = new Date();
  let year = date.getFullYear();

  return (
    <footer
      id="footer"
      className="footer bg-primary text-white "
    >
      {/* <Container className='pt-5 '> */}
      {/* <Row className='pt-3 gap-3'>
          <Col
            lg='3'
            className='me-5'
          >
            <Image
              fluid
              // src={logo}
              className='mb-3 mb-lg-5  pb-lg-4'
            ></Image>
          </Col>
        </Row> */}
      {/* <Row className='mb-5'>
          <Col
            lg='8'
            sm={{ order: 1 }}
          >
            <Row>
              <Col lg='4'>
                <h2 className='fs-4 fw-bold text-uppercase'>Contact Me!</h2>
                <Socials />
              </Col>
            </Row>
          </Col>
        </Row>

        <hr></hr> */}
      {/* </Container> */}
      <div className="footer_copyright text-center bg-secondary  d-flex align-items-center ">
        <Container className="">
          <p
            style={{ fontSize: ".8rem" }}
            className=" py-2 fw-semibold text-dark m-0"
          >
            Copyright {year}. Cheyenne Threadgill
          </p>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
